<div class="popup-by-volume">
  <div class="text-wrapper">Shipment Weight</div>
  <div class="tab">
    <div
      [class.tab-active]="loadType === 'BY_VOLUME'"
      [class.false-wrapper]="loadType !== 'BY_VOLUME'"
      (click)="handleLoadTypeChange('BY_VOLUME')"
    >
      <div>By Volume</div>
    </div>
    <div
      [class.tab-active]="loadType === 'BY_DIMENSION'"
      [class.false-wrapper]="loadType !== 'BY_DIMENSION'"
      (click)="handleLoadTypeChange('BY_DIMENSION')"
    >
      <div>By Dimension</div>
    </div>
  </div>
  @if (loadType === "BY_VOLUME") {
    <div class="service-details">
      <div class="fields" [formGroup]="totalLoadTypeForm">
        <div class="row" style="margin-bottom: 0">
          <div class="field">
            <div class="div">
              <p class="input-label">
                <span class="span">Pieces</span>
                <span class="text-wrapper-2">*</span>
              </p>
              <div class="dropdown pieces-unit">
                <span>pcs</span>
              </div>
            </div>
            <input
              id="pieces"
              type="text"
              class="input-field"
              formControlName="pieces"
              placeholder="pieces"
              appNumericInput
              [allowDecimals]="false"
              [class.error]="getError('pieces')"
            />
          </div>
          <div class="field">
            <div class="dimensions">
              <div class="label">
                <p class="input-label">
                  <span class="span">Volume</span>
                  <span class="text-wrapper-2">*</span>
                </p>
                <div class="dropdown-2">
                  <div
                    class="dropdown-wrapper"
                    #volumeUnitInput
                    (click)="togglePopover('volume')"
                  >
                    <span class="label">{{ selectedVolumeUnit }}</span>
                    <img
                      src="/assets/media/icons/chevron.svg"
                      alt="chevron"
                      class="ms-1"
                    />
                  </div>
                  @if (volumeUnitPopoverVisible) {
                    <div #volumeUnitPopover class="rates-popover sort">
                      @for (option of getVolumeUnitOptions(); track option) {
                        <div
                          class="item"
                          [class.active]="selectedVolumeUnit === option.value"
                          (click)="selectVolumeUnitOption(option.value)"
                        >
                          {{ option.label }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <input
              id="volume"
              type="text"
              class="input-field"
              formControlName="volume"
              placeholder="0.00"
              appNumericInput
              [allowDecimals]="true"
              [class.error]="getError('volume')"
            />
          </div>
          <div class="field">
            <div class="div">
              <p class="input-label">
                <span class="span">Weight</span>
                <span class="text-wrapper-2">*</span>
              </p>
              <div class="dropdown-2">
                <div
                  class="dropdown-wrapper"
                  #weightUnitInput
                  (click)="togglePopover('weight')"
                >
                  <span class="label">{{ selectedWeightUnit }}</span>
                  <img
                    src="/assets/media/icons/chevron.svg"
                    alt="chevron"
                    class="ms-1"
                  />
                </div>
                @if (weightUnitPopoverVisible) {
                  <div #weightUnitPopover class="rates-popover sort">
                    @for (option of getWeightUnitOptions(); track option) {
                      <div
                        class="item"
                        [class.active]="selectedWeightUnit === option.value"
                        (click)="selectWeightUnitOption(option.value)"
                      >
                        {{ option.label }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <input
              id="weight"
              type="text"
              class="input-field"
              formControlName="weight"
              placeholder="0.00"
              appNumericInput
              [allowDecimals]="true"
              [class.error]="getError('weight')"
            />
          </div>
        </div>
      </div>
      <div class="error-container">
        @for (error of getTotalErrors(); track error) {
          <span [title]="error" class="error-item">
            {{ error }}
          </span>
        }
      </div>
    </div>
  }

  @if (loadType !== "BY_VOLUME") {
    <div class="service-details" [formGroup]="dimensionLoadTypeForm">
      <div class="fields" formArrayName="dimensions">
        <div class="sticky-header">
          <div
            class="div"
            style="width: 120px; max-width: 120px; min-width: 120px"
          >
            <p class="input-label">
              <span class="span">Pieces</span>
              <span class="text-wrapper-2">*</span>
            </p>
            <div class="dropdown pieces-unit">
              <span>pcs</span>
            </div>
          </div>
          <div
            class="div"
            style="width: 300px; max-width: 300px; min-width: 300px"
          >
            <div class="dimensions">
              <div class="label">
                <p class="input-label">
                  <span class="span">Dimensions (LxWxH)</span>
                  <span class="text-wrapper-2">*</span>
                </p>
                <div class="dropdown-2" style="width: 61px">
                  <div
                    class="dropdown-wrapper"
                    #volumeUnitInput
                    (click)="togglePopover('volume')"
                  >
                    <span class="label">{{ selectedDimensionUnit }}</span>
                    <img
                      src="/assets/media/icons/chevron.svg"
                      alt="chevron"
                      class="ms-1"
                    />
                  </div>
                  @if (volumeUnitPopoverVisible) {
                    <div
                      #volumeUnitPopover
                      class="rates-popover sort dimension"
                    >
                      @for (option of getDimensionUnitOptions(); track option) {
                        <div
                          class="item"
                          [class.active]="
                            selectedDimensionUnit === option.value
                          "
                          (click)="selectDimensionUnitOption(option.value)"
                        >
                          {{ option.label }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div
            class="div"
            style="width: 120px; max-width: 120px; min-width: 120px"
          >
            <p class="input-label">
              <span class="span">Weight</span>
              <span class="text-wrapper-2">*</span>
            </p>
            <div class="dropdown-2">
              <div
                class="dropdown-wrapper"
                #weightUnitInput
                (click)="togglePopover('weight')"
              >
                <span class="label">{{ selectedDimensionWeightUnit }}</span>
                <img
                  src="/assets/media/icons/chevron.svg"
                  alt="chevron"
                  class="ms-1"
                />
              </div>
              @if (weightUnitPopoverVisible) {
                <div #weightUnitPopover class="rates-popover sort">
                  @for (option of getWeightUnitOptions(); track option) {
                    <div
                      class="item"
                      [class.active]="
                        selectedDimensionWeightUnit === option.value
                      "
                      (click)="selectDimensionWeightUnit(option.value)"
                    >
                      {{ option.label }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="scrollable-container">
          @for (
            dimension of dimensions.controls;
            track dimension;
            let i = $index
          ) {
            <div class="row" [formGroupName]="i">
              <div
                class="field"
                style="width: 120px; max-width: 120px; min-width: 120px"
              >
                <input
                  id="pieces"
                  type="text"
                  class="input-field"
                  formControlName="pieces"
                  placeholder="pieces"
                  appNumericInput
                  [allowDecimals]="false"
                  [class.error]="getDimensionError('pieces', i)"
                />
              </div>
              <div
                class="field"
                style="width: 300px; max-width: 300px; min-width: 300px"
              >
                <div class="d-flex flex-row align-items-center">
                  <div class="d-flex flex-column">
                    <input
                      id="length"
                      type="text"
                      class="input-field"
                      formControlName="length"
                      placeholder="0.00"
                      appNumericInput
                      [allowDecimals]="true"
                      [class.error]="getDimensionError('length', i)"
                    />
                  </div>
                  <span class="separator">X</span>
                  <div class="d-flex flex-column">
                    <input
                      id="width"
                      type="text"
                      class="input-field"
                      formControlName="width"
                      placeholder="0.00"
                      appNumericInput
                      [allowDecimals]="true"
                      [class.error]="getDimensionError('width', i)"
                    />
                  </div>
                  <span class="separator">X</span>
                  <div class="d-flex flex-column">
                    <input
                      id="height"
                      type="text"
                      class="input-field"
                      formControlName="height"
                      placeholder="0.00"
                      appNumericInput
                      [allowDecimals]="true"
                      [class.error]="getDimensionError('height', i)"
                    />
                  </div>
                </div>
              </div>
              <div
                class="field"
                style="width: 120px; max-width: 120px; min-width: 120px"
              >
                <input
                  id="weight"
                  type="text"
                  class="input-field"
                  formControlName="weight"
                  placeholder="0.00"
                  appNumericInput
                  [allowDecimals]="true"
                  [class.error]="getDimensionError('weight', i)"
                />
              </div>
              <div style="width: auto" class="p-0">
                <div
                  class="dimension-type-switch"
                  [class.align-top]="i === 0"
                  [class.align-bottom]="i !== 0"
                >
                  <div
                    class="switch-option"
                    [class.active]="
                      dimension.get('weightType')?.value === 'PER_PIECE'
                    "
                    (click)="dimension.get('weightType')?.setValue('PER_PIECE')"
                  >
                    Per Piece
                  </div>
                  <div
                    class="switch-option"
                    [class.active]="
                      dimension.get('weightType')?.value === 'BY_VOLUME'
                    "
                    (click)="dimension.get('weightType')?.setValue('BY_VOLUME')"
                  >
                    Total
                  </div>
                </div>
              </div>
              <svg
                class="p-0"
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [class.hidden]="i === 0"
                [class.align-bottom]="i !== 0"
                (click)="removeDimensionRow(i)"
                style="cursor: pointer; width: auto"
              >
                <g id="Delete">
                  <path
                    id="Vector"
                    d="M18.5625 4.125H3.4375C3.25516 4.125 3.0803 4.19743 2.95136 4.32636C2.82243 4.4553 2.75 4.63016 2.75 4.8125C2.75 4.99484 2.82243 5.1697 2.95136 5.29864C3.0803 5.42757 3.25516 5.5 3.4375 5.5H4.125V17.875C4.125 18.2397 4.26987 18.5894 4.52773 18.8473C4.78559 19.1051 5.13533 19.25 5.5 19.25H16.5C16.8647 19.25 17.2144 19.1051 17.4723 18.8473C17.7301 18.5894 17.875 18.2397 17.875 17.875V5.5H18.5625C18.7448 5.5 18.9197 5.42757 19.0486 5.29864C19.1776 5.1697 19.25 4.99484 19.25 4.8125C19.25 4.63016 19.1776 4.4553 19.0486 4.32636C18.9197 4.19743 18.7448 4.125 18.5625 4.125ZM16.5 17.875H5.5V5.5H16.5V17.875ZM6.875 2.0625C6.875 1.88016 6.94743 1.7053 7.07636 1.57636C7.2053 1.44743 7.38016 1.375 7.5625 1.375H14.4375C14.6198 1.375 14.7947 1.44743 14.9236 1.57636C15.0526 1.7053 15.125 1.88016 15.125 2.0625C15.125 2.24484 15.0526 2.4197 14.9236 2.54864C14.7947 2.67757 14.6198 2.75 14.4375 2.75H7.5625C7.38016 2.75 7.2053 2.67757 7.07636 2.54864C6.94743 2.4197 6.875 2.24484 6.875 2.0625Z"
                    fill="#7E47C5"
                  />
                </g>
              </svg>
              <div class="error-container">
                @for (error of getDimensionErrors(i); track error) {
                  <span [title]="error?.message" class="error-item">
                    {{ error?.message }}
                  </span>
                }
              </div>
            </div>
          }
        </div>
      </div>
      @if (loadType !== "BY_VOLUME") {
        <button class="add-button" type="button" (click)="addDimensionRow()">
          + Add
        </button>
      }
      @if (isVolumeLow) {
        <div class="error-container">
          <div class="error-item mt-2">Minimum Volume is 0.0001</div>
        </div>
      }
    </div>
  }
  @if (!!this.previousData) {
    <div class="recent-searches-wrapper">
      <div class="title d-flex align-items-center">
        <div class="border"></div>
        <span
          class="recent-searches-label"
          i18n="@@rates-load-type.recent-searches"
        >
          Recent Searches</span
        >
      </div>
      <div class="recent-searches-chips">
        <div class="wrapper">
          <div class="clickable" (click)="onClickRecentSearch()">
            <span class="chip-pieces">{{ dimensionPieces(true) }}</span>
            <span
              class="d-flex align-items-center"
              style="position: relative; bottom: 3px"
              >.</span
            >
            <span class="chip-volume">{{ dimensionVolume(true) }},</span>
            <span class="chip-weight">{{ dimensionWeight(true) }}</span>
          </div>
          <span
            class="d-flex justify-content-end flex-fill"
            (click)="deleteRecentSearches()"
          >
            <img
              src="/assets/media/icons/x-circle.svg"
              alt="x-circle"
              style="cursor: pointer"
            />
          </span>
        </div>
      </div>
    </div>
  }
  <div class="buttons">
    <button class="button-primary">
      <div class="button-content" (click)="cancel()">
        <div class="text">Cancel</div>
      </div>
    </button>
    <div class="button-content-wrapper">
      <button
        class="button-content-2"
        [disabled]="isCalculateButtonDisabled"
        (click)="handleCalculate()"
      >
        <div class="text-2">Calculate</div>
      </button>
    </div>
  </div>
</div>
